import {Component, prop, watch} from 'vue-property-decorator';

@Component({
    template: require('./selector.html'),
    components: {

    }
})
export class Selector {
    @prop(Array)
    diets;

    change(event) {
        this.$emit('change', event.target.value);
    }

    close(event) {
        if(!$(event.target).closest('.popup').length) {
            this.$emit('close');
        }
    }
}
